<template>
  <div class="container mx-auto mt-10 sm:mt-20">
    <!-- Project header -->
    <ProjectHeader :singleProjectHeader="singleProjectHeader" />

    <!-- Project gallery -->
    <ProjectGallery :projectImages="projectImages" />

    <!-- Project information -->
    <ProjectInfo :projectInfo="projectInfo" />

    <!-- Project related projects -->
    <ProjectRelatedProjects :relatedProject="relatedProject" />
  </div>
</template>

<script>
import feather from 'feather-icons';
import ProjectHeader from '../components/projects/ProjectHeader.vue';
import ProjectGallery from '../components/projects/ProjectGallery.vue';
import ProjectInfo from '../components/projects/ProjectInfo.vue';
import ProjectRelatedProjects from '../components/projects/ProjectRelatedProjects.vue';
import projects from '../data/projects.js';

export default {
  name: 'Projects',
  components: {
    ProjectHeader,
    ProjectGallery,
    ProjectInfo,
    ProjectRelatedProjects,
  },
  data: () => {
    return {
      project: null,
      projectId: null,
      singleProjectHeader: {
        singleProjectTitle: '',
        singleProjectDate: '',
        singleProjectTag: '',
      },
      projectImages: [],
      projectInfo: {
        // objectivesHeading: 'Role',
        // projectRole: 'UI',
        technologies: {
          // title: 'Tools & Technologies',
          techs: '',
        },
        // projectDetailsHeading: 'Challenge',
        projectDetails: [
          { id: 1, details: '' },
          { id: 2, details: '' },
        ],
        url: {
          // title: 'Project URL',
          link: '',
        }
      },
      relatedProject: {
        relatedProjectsHeading: 'Related Projects',
        relatedProjects: [],
      },
    };
  },
  created() {
    // clean the codes below
    this.project = projects[this.$route.params.id - 1];
    this.projectId = this.$route.params.id - 1;
    this.singleProjectHeader.singleProjectTitle = this.project.title;
    this.singleProjectHeader.singleProjectDate = this.project.date;
    this.singleProjectHeader.singleProjectTag = this.project.category;
    this.projectImages = [
      { id: 1, img: this.project.img1 },
      { id: 2, img: this.project.img2 },
      { id: 3, img: this.project.img3 },
      { id: 4, img: this.project.img4 }
    ];
    this.projectInfo.projectRole = this.project.role;
    this.projectInfo.technologies.techs = this.project.skills;
    this.projectInfo.projectDetails[0].details = this.project.p1;
    this.projectInfo.projectDetails[1].details = this.project.p2;
    this.projectInfo.url.link = this.project.url;
    // related projects
    projects.forEach((item) => {
      if (item.id == this.projectId + 1) {
        return;
      }
      // limit by 4 item
      if (this.relatedProject.relatedProjects.length >= 4) {
        return;
      }
      this.relatedProject.relatedProjects.push({
        id: item.id,
        title: item.title,
        img: item.img1,
      });
    })
  },
  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  },
  methods: {},
};
</script>

<style scoped></style>
